import {Client} from "../../domain/model/client";
import {MessageRoom} from "../../domain/model/message_room";
import {Project} from "../../domain/model/project";
import {Message} from "../../domain/model/message";
import {TCompanyWithProjectID} from "../../domain/repository/company_repository";
import {Customer} from "../../domain/model/customer";
import {TMessageSignature} from "../type/common";
import { Contract } from "src/domain/model/contract";

interface ICreateMessageRoomByClientResponse {
    messageRoom?: MessageRoom;
    messages?: Message[];
    project?: Project;
    ownSignature?: TMessageSignature;
    opponentSignature?: TMessageSignature;
}
class CreateMessageRoomByClientResponse implements ICreateMessageRoomByClientResponse {
    public messageRoom: MessageRoom;
    public messages: Message[];
    public project: Project;
    public ownSignature: TMessageSignature;
    public opponentSignature: TMessageSignature;
}

interface IObserveMessageRoomByClientResponse {
    message?: Message;
}
class ObserveMessageRoomByClientResponse implements IObserveMessageRoomByClientResponse {
    public message: Message;
}

interface IStartPollingMessageRoomsByClientResponse {

    messageRooms?: MessageRoom[];
    customers?: Customer[];
    projects?: Project[];
    latestMessages?: Message[];
    initialMessageRoom?: MessageRoom | null;
    contracts?: Contract[];

}
class StartPollingMessageRoomsByClientResponse implements IStartPollingMessageRoomsByClientResponse {

    public messageRooms: MessageRoom[];
    public customers: Customer[];
    public projects: Project[];
    public latestMessages: Message[];
    public initialMessageRoom: MessageRoom | null;
    public contracts: Contract[];

}

interface IStartPollingMessageRoomsByCustomerResponse {

    messageRooms?: MessageRoom[];
    companyWithProjectIDs?: TCompanyWithProjectID[];
    clients?: Client[];
    projects?: Project[];
    latestMessages?: Message[];
    initialMessageRoom?: MessageRoom | null;
    contracts?: Contract[];

}
class StartPollingMessageRoomsByCustomerResponse implements IStartPollingMessageRoomsByCustomerResponse {

    public messageRooms: MessageRoom[];
    public companyWithProjectIDs: TCompanyWithProjectID[];
    public projects: Project[];
    public latestMessages: Message[];
    public initialMessageRoom: MessageRoom | null;
    public contracts: Contract[];

}

interface ICreateMessageRoomByCustomerResponse {
    messageRoom?: MessageRoom;
    messages?: Message[];
    project?: Project;
    ownSignature?: TMessageSignature;
    opponentSignature?: TMessageSignature;
}
class CreateMessageRoomByCustomerResponse implements ICreateMessageRoomByCustomerResponse {
    public messageRoom: MessageRoom;
    public messages: Message[];
    public project: Project;
    public ownSignature: TMessageSignature;
    public opponentSignature: TMessageSignature;
}

interface IObserveMessageRoomByCustomerResponse {

    message?: Message;

}
class ObserveMessageRoomByCustomerResponse implements IObserveMessageRoomByCustomerResponse {

    public message: Message;

}

export {
    CreateMessageRoomByClientResponse,
    ObserveMessageRoomByClientResponse,

    StartPollingMessageRoomsByClientResponse,

    StartPollingMessageRoomsByCustomerResponse,

    CreateMessageRoomByCustomerResponse,
    ObserveMessageRoomByCustomerResponse
}



// WEBPACK FOOTER //
// ./src/presentation/response/message_room_response.ts